const blue = '#2196f3';
const purple = '#666ee8';
const blue_grey = '#586e82';
const grey = '#F5F6F8';
const red = '#ff4961';
const green = '#28d094';
const yellow = '#f1cb1c';
const orange = '#ff9c07';
const crimson = '#e92763';

export { blue, purple, blue_grey, grey, red, green, yellow, orange, crimson };
